<template>
  <div id="gallery">
    <v-container v-if="!loading">
      <v-dialog v-model="triggerInfo.dialog" max-width="600">
        <v-card color="card">
          <v-toolbar color="toolbar">
            <v-toolbar-title> AutoCollect Trigger Info </v-toolbar-title>
          </v-toolbar>
          <v-container>
            <v-data-table
              :items="triggerInfo.info"
              :headers="triggerInfo.headers"
              :items-per-page="5"
            >
            </v-data-table>
          </v-container>
        </v-card>
      </v-dialog>
      <v-card
        :loading="loading"
        class="rounded-xl d-flex flex-column mb-2"
        elevation="8"
      >
        <v-img
          :src="collectionImage()"
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,1.0)"
          height="200px"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
          <v-card-title>
            {{ collection.name }}
          </v-card-title>
          <v-card-subtitle v-if="collection.users.length">
            <v-icon> mdi-swap-horizontal </v-icon>
            {{ collection.user.username }},
            {{ collection.users.map((user) => user.user.username).join(", ") }}
          </v-card-subtitle>
        </v-img>
      </v-card>
      <br /><br />
      <GalleryNext
        :items="items"
        :selected="selected"
        :set-page="setPage"
        :getItems="getItems"
        :page-value="page"
        :supports="{
          multiSelect: true,
          collections: true,
          randomAttachment: false
        }"
        :loading="loading"
        :multi-select="multiSelect"
        @setPage="page = $event"
      >
        <template v-slot:multi-select-actions-length="{ selected }">
          <v-btn class="rounded-xl ml-2" text @click="selectAll(selected)">
            <v-icon>mdi-plus</v-icon>&nbsp;Select all
          </v-btn>
          <v-btn class="rounded-xl ml-2" text @click="deselectAll(selected)">
            <v-icon>mdi-close</v-icon>&nbsp;Unselect all
          </v-btn>
          <v-btn
            class="rounded-xl"
            color="red darken-1"
            text
            @click="bulkAct('deny', selected)"
            ><v-icon>mdi-close</v-icon> Reject all</v-btn
          >
          <v-btn
            class="rounded-xl ml-2"
            color="success"
            text
            @click="bulkAct('approve', selected)"
          >
            <v-icon>mdi-check</v-icon>&nbsp;Accept all
          </v-btn>
        </template>
        <template v-slot:actions="{ item }">
          <HoverChip
            text="Approve"
            icon="mdi-check"
            color="green"
            @click="act(item.id, 'approve')"
          ></HoverChip>
          <HoverChip
            text="Reject"
            icon="mdi-close"
            color="red"
            @click="act(item.id, 'deny')"
          ></HoverChip>
          <HoverChip
            text="Trigger Info"
            icon="mdi-help"
            color="info"
            @click="openTriggerInfo(item)"
          ></HoverChip>
        </template>
      </GalleryNext>
    </v-container>
    <v-container v-else>
      <v-row>
        <v-col>
          <v-card class="rounded-xl" elevation="7">
            <v-container class="text-center">
              <p class="text-lg-h4">Loading...</p>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"
import HoverChip from "@/components/HoverChip"
import GalleryNext from "@/components/Gallery"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)

export default {
  name: "AutoCollectItem",
  components: {
    GalleryNext,
    HoverChip
  },
  data() {
    return {
      settings: {
        dialog: false
      },
      uploadDialog: false,
      items: {
        items: [],
        pager: []
      },
      collection: {
        users: []
      },
      selected: [],
      show: {
        metadata: true,
        selected: "all",
        search: "",
        types: [
          {
            name: "All",
            internalName: "all"
          },
          {
            name: "Images",
            internalName: "image"
          },
          {
            name: "Videos",
            internalName: "video"
          },
          {
            name: "Audio",
            internalName: "audio"
          },
          {
            name: "Text",
            internalName: "text"
          },
          {
            name: "Pastes",
            internalName: "paste"
          },
          {
            name: "Other",
            internalName: "binary"
          }
        ]
      },
      loading: false,
      page: 1,
      triggerInfo: {
        dialog: false,
        info: [],
        headers: [
          {
            text: "Reason",
            value: "reason"
          },
          {
            text: "Value",
            value: "value"
          },
          {
            text: "Rule ID",
            value: "ruleId"
          }
        ]
      }
    }
  },
  methods: {
    doSinglePulse(type, other, timeOnPage) {
      this.$socket.emit("pulse", {
        action: type,
        timeSpent: timeOnPage || 0,
        route: this.$route.path,
        device: navigator.device,
        sysInfo: {
          ua: navigator.userAgent
        },
        name: null,
        other
      })
    },
    openTriggerInfo(item) {
      if (!item.info) return
      this.triggerInfo.info = item.info
      this.triggerInfo.dialog = true
    },
    selectAll(selected) {
      selected = this.items.gallery.map((item) => item.id)
    },
    deselectAll(selected) {
      selected = []
    },
    multiSelect(item) {
      if (this.selected.includes(item.id)) {
        this.selected.splice(this.selected.indexOf(item.id), 1)
      } else {
        this.selected.push(item.id)
      }
    },
    act(id, action) {
      this.axios
        .post("/api/v1/autoCollect/" + id, {
          action
        })
        .then(() => {
          this.$toast.success("Action performed")
          this.getItems(true, false, false)
          const type =
            action === "approve"
              ? "auto-collect-accepted"
              : "auto-collect-rejected"
          this.doSinglePulse(type, {
            collectionId: this.collection.id,
            count: 1
          })
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    bulkAct(action, selected) {
      this.axios
        .post("/api/v1/autoCollect/bulk", {
          action,
          ids: selected
        })
        .then(() => {
          this.$toast.success("Action performed")
          this.getItems(true, false, false)
          const type =
            action === "approve"
              ? "auto-collect-accepted"
              : "auto-collect-rejected"
          this.doSinglePulse(type, {
            collectionId: this.collection.id,
            count: this.selected.length
          })
          selected = []
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    setPage(event) {
      this.page = parseInt(event.target.value)
    },
    collectionImage() {
      if (this.collection?.preview?.attachment) {
        return "/i/" + this.collection.preview.attachment.attachment
      } else {
        return "https://i.troplo.com/i/a050d6f271c3.png"
      }
    },
    search() {},
    dayjs(params) {
      return dayjs(params)
    },
    fileSize(fileSize) {
      let i = -1
      let byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      do {
        fileSize = fileSize / 1024
        i++
      } while (fileSize > 1024)

      return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i]
    },
    getCollection() {
      this.axios
        .get("/api/v1/collections/personal/" + this.$route.params.id)
        .then((res) => {
          this.collection = res.data
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getItems(init, resetPage, load = true) {
      if (resetPage) {
        this.page = 1
      }
      if (load) {
        this.loading = true
      }
      this.axios
        .get(
          "/api/v1/autoCollect/" +
            this.$route.params.id +
            "/pending?page=" +
            this.page +
            "&filter=" +
            this.show.selected +
            "&search=" +
            this.show.search +
            "&textMetadata=" +
            this.show.metadata
        )
        .then((res) => {
          this.items = res.data
          this.items.gallery = res.data.gallery.map((item) => {
            return {
              ...item.attachment,
              ...item,
              id: item.id,
              attachment: item.attachment.attachment
            }
          })
          if (!this.items.gallery.length) {
            this.$router.push("/autoCollect")
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getItems(true, true)
    this.getCollection()
  },
  watch: {
    page() {
      this.getItems(true, false)
      this.getCollection()
    },
    $route() {
      this.getItems(true, true)
      this.getCollection()
    }
  }
}
</script>

<style scoped></style>
